import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPersonnelFieldUpdate, IPersonnelState } from 'src/types/SiteStudyPersonal';

const initialState: IPersonnelState = {
  personnel: {},
  siteChecked: false,
  siteCheckedId: '',
  personnel_site_per_training: []
};

export const personnel = createSlice({
  name: 'personnel',
  initialState,
  reducers: {
    clearPersonnel: state => {
      state.personnel = {};
    },
    clearPersonnelState: state => {
      state.personnel = {};
      state.siteChecked = false;
      state.siteCheckedId = '';
      state.personnel_site_per_training = [];
    },
    setPersonnelField: (state, action: PayloadAction<IPersonnelFieldUpdate>) => {
      state.personnel[action.payload.key] = action.payload.value;
    },
    clearRequestChecked: state => {
      state.siteChecked = false;
      state.siteCheckedId = '';
    },
    setRequestChecked: (state, action: PayloadAction<{ checked: boolean; id: string }>) => {
      state.siteChecked = action.payload.checked;
      state.siteCheckedId = action.payload.id;
    },
    setSitePerTraining: (state, action: PayloadAction<{ site_per_training: string; id: string }>) => {
      const element = state.personnel_site_per_training.find(ele => ele.id === action.payload.id);
      if (element) {
        element.site_per_training = action.payload.site_per_training;
      } else {
        state.personnel_site_per_training.push({
          id: action.payload.id,
          site_per_training: action.payload.site_per_training
        });
      }
    },
    clearSitePerTraining: state => {
      state.personnel_site_per_training = [];
    }
  }
});

export const {
  setRequestChecked,
  clearRequestChecked,
  clearPersonnel,
  setPersonnelField,
  clearPersonnelState,
  setSitePerTraining,
  clearSitePerTraining
} = personnel.actions;
